import { render, staticRenderFns } from "./SortField.vue?vue&type=template&id=363f1dc2&scoped=true"
import script from "./SortField.vue?vue&type=script&lang=js"
export * from "./SortField.vue?vue&type=script&lang=js"
import style0 from "./SortField.vue?vue&type=style&index=0&id=363f1dc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363f1dc2",
  null
  
)

export default component.exports